import { forwardRef } from 'react';

import { StyledMenuItem, SubMenuIndicator } from './styles/Menu';

const MenuItem = forwardRef(function MenuItem(
  { hasSubMenu, children, isOpen, isCurrent, ...props },
  ref
) {
  const subMenuProps = hasSubMenu
    ? {
        // null removes prop as per w3 spec
        $hasSubMenu: hasSubMenu,
        'aria-expanded': isOpen || null,
      }
    : {};

  return (
    <StyledMenuItem ref={ref} $isOpen={isOpen} $isCurrent={isCurrent} {...subMenuProps} {...props}>
      {children}
      {hasSubMenu && <SubMenuIndicator $isOpen={isOpen} $isCurrent={isCurrent} />}
    </StyledMenuItem>
  );
});

export default MenuItem;
